import React from 'react';
import _ from "underscore";

import RetinaImage from "react-retina-image"
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import config from '../../config';
import DesignerMenuItem from "./common/DesignerMenuItem";

const ItemsMenuSimplified = ({ menu_item, collections, collections_prefix, show_designers_menu }) => {
    const designers_list = menu_item.manual_designers_list;

    return (
        <div className="top-nav">
            <Container>
                <Row>
                    {collections && collections.values && collections.values.length > 0 &&
                    <Col xl={{ span: 2, offset: 1 }} lg={{ span: 3, offset: 0 }} >
                        <h4 className="top-nav__nav-title">{menu_item.title}</h4>
                        <Nav className="top-nav__nav-list">
                            {_.map(collections.values.slice(0, 10), (collection, idx) => {
                                const collectionEncoded = encodeURIComponent(collection.key ? collection.key : collection.label);
                                return (
                                    <Nav.Item
                                        key={idx}
                                        className="top-nav__nav-list-item-primary nav-link nav-top-link"
                                        as="a"
                                        href={`${collection.handle ? config.host_rebag_shop + "/collections/" + collection.handle : menu_item.href + "?" + menu_item.collections_filter_key + "=" + collectionEncoded}`}
                                    >
                                        {collection.label ? collection.label : collection.key.replace(collections_prefix, "")}
                                    </Nav.Item>
                                );
                            })}
                        </Nav>
                    </Col>
                    }
                    {designers_list && designers_list.length > 0 &&
                    <Col lg={3}>
                        <h4 className="top-nav__nav-title">{menu_item.collections_info.title}</h4>
                        <Nav className="top-nav__nav-list">
                            <Nav.Item
                                className="top-nav__nav-list-item-secondary color-gray"
                            >
                                Designers A - Z
                            </Nav.Item>
                            {_.map(designers_list.slice(0, 9), (designer) => {
                                return (
                                    <DesignerMenuItem
                                        key={designer.slug}
                                        url={menu_item.href}
                                        menu_item={menu_item}
                                        designer={designer}
                                        show_designers_menu={show_designers_menu}
                                        classname="top-nav__nav-list-item-secondary"
                                    />
                                )
                            })}
                        </Nav>
                    </Col>
                    }
                    <Col lg={6}>
                        <a
                            href={menu_item.img_url}
                            className="top-nav__promo-image-link"
                        >
                            {menu_item && menu_item.img &&
                            <RetinaImage
                                alt={`All ${menu_item.title}`}
                                title={`All ${menu_item.title}`}
                                className="top-nav__promo-image"
                                src={menu_item.img}
                            />
                            }
                        </a>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default ItemsMenuSimplified;